var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "forgetPwdFrom", attrs: { id: "forgetPwdContent" } },
    [
      _c("h2", { staticClass: "sign-title" }, [
        _vm._v(_vm._s(_vm.$t("language.forgetPwd.title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "font14" }, [
        _vm._v(_vm._s(_vm.$t("language.forgetPwd.tip")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mc-row" }, [
        _c(
          "label",
          {
            staticClass: "ic-label ic-email",
            class: _vm.inputClass(_vm.selectInput.email),
            attrs: { for: "" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass: "width100",
              class: _vm.inputClass(_vm.selectInput.email),
              attrs: {
                type: "text",
                name: "email",
                placeholder: _vm.$t("language.popup.email"),
                autoComplete: "off"
              },
              domProps: { value: _vm.email },
              on: {
                focus: function($event) {
                  return _vm.focusInput("email")
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "err tips-info",
            class: _vm.tipsClass(_vm.selectInput.email)
          },
          [_vm._v(_vm._s(_vm.tipsMsg.email))]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        ref: "turnstileContainer",
        staticClass: "turnstile-container"
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mc-row btn" }, [
        _c(
          "p",
          {
            staticClass: "err tips-info",
            class: _vm.tipsClass(_vm.selectInput.btn)
          },
          [_vm._v(_vm._s(_vm.tipsMsg.btn))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "login-btn",
            class: _vm.selectInput.btn == "sending" ? "no-click" : "",
            on: {
              click: function($event) {
                return _vm.forgetPwd()
              }
            }
          },
          [
            _vm.selectInput.btn == "sending"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("language.forgetPwd.sending")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("language.forgetPwd.btnTxt")))
                ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "font13" }, [
        _c("p", { staticClass: "f-margintop1" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("language.forgetPwd.tips1")) +
              " \n            "
          ),
          _c(
            "a",
            {
              staticClass: "alink",
              attrs: { href: "mailto:support@multcloud.com" }
            },
            [_vm._v(_vm._s(_vm.$t("language.forgetPwd.tips2")))]
          ),
          _vm._v(
            " \n            " +
              _vm._s(_vm.$t("language.forgetPwd.tips3")) +
              "\n        "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026506a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026506a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/share_page_popups/forget_pwd_popup.vue
// module id = null
// module chunks = 